import {Text} from "@mantine/core";
import {Entity, getRequiredObjectId} from "@ots-frontend/ots-data";
import {lazy, Suspense} from "react";

const ObjectRestrictionsPanel = lazy(() =>
  import("@ots-frontend/ots-ui-tw").then(module => ({
    default: module.ObjectRestrictionsPanel,
  }))
);

export type RestrictionDataTableCardProps = {
  entity: Entity
}

/** Bridge for the Mantine profiles; the restriction UI itself lives in ots-ui-tw. */
export const RestrictionDataTableCard = ({entity}: RestrictionDataTableCardProps) => (
  <Suspense fallback={<Text size="sm" color="dimmed">Loading restrictions…</Text>}>
    <ObjectRestrictionsPanel
      objectId={getRequiredObjectId(entity)}
      objectType={entity.entityType}/>
  </Suspense>
);
